import React, { useState } from 'react';
import { Box, Button, Grid, Typography } from '@mui/material';
import SaveButton from 'components/buttonsComponent/SaveButton';
import DownloadIcon from '@mui/icons-material/Download';
import { width } from '../../../node_modules/@mui/system/index';
import DownloadButton from 'components/buttonsComponent/DownloadButton';
import { FaDownload } from "react-icons/fa";
import UserIdButton from 'components/buttonsComponent/UserIdButton';

const DownloadPostReviewGapForm = ({ onNext }) => {
    const [isDownloaded, setIsDownloaded] = useState(false);
    const formImageUrl = '../../assets/images/GriCustomizeForm.png';

    const handleDownloadClick = () => {
        const link = document.createElement('a');
        link.href = formImageUrl;
        link.download = 'Post_Review_Gap_Form.docs';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        setIsDownloaded(true);
    };

    const handleNext = () => {
        if (onNext) onNext();
        setIsDownloaded(false);
    };

    return (
        <Grid container spacing={2}>
            <Grid item xs={12}>
                <Box
                    className="standards-header"
                    sx={{
                        display: 'flex',
                        justifyContent: 'flex-end',
                        alignItems: 'center',
                        flexWrap: 'wrap',
                        gap: 2,
                        [theme => theme.breakpoints.down('sm')]: {
                            justifyContent: 'center',
                            flexDirection: 'column',
                            alignItems: 'stretch',
                        },
                    }}
                >
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            gap: 2,
                            alignItems: 'center',
                        }}
                    >

                        <SaveButton
                        // onClick={handleSave}
                        >
                            Save
                        </SaveButton>
                        <UserIdButton />
                    </Box>
                </Box>
            </Grid>

            <Grid item xs={12}>
                <Typography
                    variant="h6"
                    className="mx-4"
                    sx={{
                        fontFamily: 'DM Sans',
                        fontWeight: 800,
                        fontSize: '24px',
                        lineHeight: '42px',
                        color: '#02462E',
                        marginBottom: '24px',
                    }}
                >
                    Download Post Review Gap form
                </Typography>
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        padding: '24px',
                        textAlign: 'center',
                    }}
                >
                    <Typography
                        sx={{
                            fontFamily: 'DM Sans',
                            fontWeight: 700,
                            fontSize: '24px',
                            lineHeight: '32px',
                            color: '#28A745',
                            marginBottom: '8px',
                            textAlign: 'center', // Center align for all breakpoints
                        }}
                    >
                        Download Post Review Gap form
                    </Typography>

                    <Typography
                        sx={{
                            fontFamily: 'DM Sans',
                            fontWeight: 400,
                            fontSize: '16px',
                            lineHeight: '26px',
                            color: '#A3AED0',
                            marginBottom: '24px',
                            width: {
                                xs: '90%', // Constrain width on small screens
                                sm: '70%', // Slightly narrower on medium screens
                                md: '50%', // Narrower on larger screens
                            },
                            textAlign: 'center', // Ensure text is centered
                            mx: 'auto', // Center the block horizontally
                        }}
                    >
                        Please download the Post-Review Gap Form, generated based on your review comments and submitted evidence. Kindly review and prepare the necessary supporting documents
                    </Typography>

                    <DownloadButton
                        title="Download Post Review Gap Form"
                        isDownloaded={isDownloaded}
                        onClick={handleDownloadClick}
                        endIcon={<FaDownload sx={{ fontSize: 20 }} />}
                    />
                </Box>
            </Grid>

            {isDownloaded && (
                <Grid item xs={12}>
                    <Box
                        sx={{
                            display: 'flex',
                            justifyContent: 'flex-end',
                            padding: '0 24px 24px 0',
                        }}
                    >
                        <Button
                            variant="contained"
                            sx={{
                                width: '252px',
                                height: '50px',
                                background: '#02462E',
                                color: '#fff',
                                px: 2,
                                py: 1,
                                textTransform: 'none',
                                '&:hover': { background: '#02462E' },
                            }}
                            onClick={handleNext}
                        >
                            Next
                        </Button>
                    </Box>
                </Grid>
            )}
        </Grid>
    );
};

export default DownloadPostReviewGapForm;